import React, { ReactElement } from 'react';
import classNames from 'classnames';

import Image from 'vibo-ui/Image';
import SongArtistNames from 'components/songs/SongArtistNames';

import { getSmallestAvailableThumbnail } from 'services/songs/helpers';
import { getSectionSongsInfo } from 'services/sections/helpers';

import { SectionSongPreviewProps } from './interfaces';

import useStyles from './style';

const SectionSongPreview = <TSection extends SectionBase & SectionWithSongsInfoBase>({
  section,
  className,
}: SectionSongPreviewProps<TSection>): ReactElement => {
  const classes = useStyles();

  const src = getSmallestAvailableThumbnail(section.coverSong.thumbnails);

  return (
    <div className={classNames('songPreview', classes.sectionSongPreview, className)}>
      {section.coverSong ? (
        <>
          <Image
            src={src}
            alt={getSectionSongsInfo(section)}
            gradientId={getSmallestAvailableThumbnail(section.coverSong.thumbnails)}
            className={classNames('imageContainer', classes.imageContainer)}
          />
          <SongArtistNames song={section.coverSong} />
        </>
      ) : null}
    </div>
  );
};

export default SectionSongPreview;
